
const tableStyles = {
    tableWrapper: {
        maxHeight: "570px",
        overflowY: "auto",
        overflowX: "auto",
        border: "1px solid #dce3eb",
        borderRadius: "8px",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        minWidth: "800px",
    },
    headerCell: {
        padding: "10px 12px",
        textAlign: "center",
        borderBottom: "2px solid #dce3eb",
        backgroundColor: "#f2f6f9",
        fontWeight: 600,
        fontSize: "14px",
        position: "sticky",
        top: 0,
        zIndex: 5,
    },
    dataCell: {
        padding: "10px 12px",
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #eaeaea",
    },
    alternateRow: {
        backgroundColor: "#fff",
    },
    noData: {
        textAlign: "center",
        padding: "20px",
        fontSize: "14px",
        color: "#888",
        fontStyle: "italic",
    },
    dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
    },
    dataRowHover: {
        backgroundColor: "#E5F1F9",
    },
};

export default tableStyles;
